import React from 'react';
import { TNavBarData } from '../../../types/THeaderConfig';

const HeaderNavBarContext = React.createContext<TNavBarData | undefined>(undefined);

export default HeaderNavBarContext;
